import { connect } from 'react-redux'

import {
  putFinanceProfileStatus,
  selectOption,
  selectReason,
} from 'reduxpath/ducks/FinanceProfile/List'

import {
  getFinanceProfileByProfileId,
  getProductByProfileId,
  getProjectByProfileId,
} from 'reduxpath/ducks/Profile/Detail'

import { getPermission } from 'reduxpath/ducks/Impersonate'

import ProfileDetail from './units'

function mapStateToProps(state) {
  const restrictFields = ['id', 'profile', 'users']
  const financeProfile =
    state.ProfileDetail.financeProfile.rows.length > 0
      ? Object.entries(state.ProfileDetail.financeProfile.rows[0]).filter(
          field => restrictFields.indexOf(field[0]) < 0,
        )
      : []
  const profilesBankInformation =
    state.ProfileDetail.profilesBankInformation.rows.length > 0
      ? Object.entries(state.ProfileDetail.profilesBankInformation.rows[0]).filter(
          field => restrictFields.indexOf(field[0]) < 0,
        )
      : []
  const content = Object.entries(state.ProfileDetail.data).filter(
    field => restrictFields.indexOf(field[0]) < 0,
  ).map((field) => {
    if (field.length > 1 && typeof field[1] === 'object') {
      const updatedField = [field[0], field[1].name]
      return updatedField
    }

    return field
  })

  return {
    users: state.ProfileDetail.data.users,
    profileName: state.ProfileDetail.data.name,
    financeProfile,
    profilesBankInformation,
    content,
    productsProfile: state.ProfileDetail.productsProfile.data,
    sortProducts: state.ProfileDetail.productsProfile.sort,
    projectsProfile: state.ProfileDetail.projectsProfile.data,
    orderStatus: state.ProfileDetail.projectsProfile.orderStatus,
    sortProjects: state.ProfileDetail.projectsProfile.sort,
    filterProjects: state.ProfileDetail.projectsProfile.filter,
    id: state.ProfileDetail.data.id,
    profileId: state.ProfileDetail.data.profileId,
    financeStatus:
      state.ProfileDetail.financeProfile.rows.length > 0
        ? state.ProfileDetail.financeProfile.rows[0].status
        : -1,
    financeProfileId:
      state.ProfileDetail.financeProfile.rows.length > 0
        ? state.ProfileDetail.financeProfile.rows[0].id
        : '',
    financePendingValue: state.Reference.financeStatus.pending.value,
    financeApprovedValue: state.Reference.financeStatus.approved.value,
    financeRejectedValue: state.Reference.financeStatus.rejected.value,
    rejectReasonRef: state.Reference.rejectReason,
    selectedOption: state.FinanceProfileList.selectedOption,
    selectedReason: state.FinanceProfileList.selectedReason,
    isLoading: state.ProfileDetail.isLoading,
  }
}

const mapDispatchToProps = dispatch => ({
  handleActionFinance(id, status, profileId, reason) {
    return e => {
      e.preventDefault()
      const data = {
        status,
        isNotified: false,
      }
      if (status === 2) {
        data.reason = reason
      }

      dispatch(
        putFinanceProfileStatus(id, data, () => {
          dispatch(getFinanceProfileByProfileId(profileId))
        }),
      )
    }
  },
  handleOnChangeOption(option) {
    return () => {
      dispatch(selectOption(option))
    }
  },
  handleOnChangeReason(option) {
    return () => {
      dispatch(selectReason(option))
    }
  },
  handleOnChangePageServiceCard(sort, profileId) {
    return key => {
      const limit = 25
      const page = key.selected
      const qs = {
        limit,
        skip: page * limit,
      }
      if (sort.active) {
        qs.sort = {
          [sort.active]: sort[sort.active],
        }
      }

      dispatch(getProductByProfileId(profileId, qs))
    }
  },
  handleOnChangePageProjects(sort, filter, profileId) {
    return key => {
      const limit = 25
      const page = key.selected
      const qs = {
        limit,
        skip: page * limit,
      }

      if (sort.active) {
        qs.sort = {
          [sort.active]: sort[sort.active],
        }
      }

      if (filter.status) {
        qs.where = {
          ...filter,
        }
      }

      dispatch(getProjectByProfileId(profileId, qs))
    }
  },
  goesTopPlatform(profileId, userEmail, profileSlug, typeDestination) {
    return () => {
      dispatch(getPermission(profileId, userEmail, profileSlug, typeDestination))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDetail)
